import * as Yup from "yup";
import "./GiveRatingModal.scss";
import { Modal, Toast } from "react-bootstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { CrossIcon, StarIcon } from "../../../../Assets/svgIcons";
import { addInfluencerRating } from "../../../../Services/prod/auth.service";
import { toast } from "react-toastify";

const GiveRatingModal = ({ show,update,setUpdate, handleClose, userId }) => {
  console.log(userId, "userId");
  const validationSchema = Yup.object({
    rating: Yup.number().min(0, "Invalid rating"),
    desc: Yup.string()
      .required("Description is required")
      .min(10, "Description must be at least 10 characters")
      .max(200, "Description must not exceed 200 characters"),
  });

  const initialValues = {
    rating: 0,
    desc: "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (values ) {
        const addRatingPayload = {
          rate_to: userId ,
          rating: values?.rating,
          comment: values?.desc,
        };
        const addRatingRes = await addInfluencerRating(addRatingPayload);
        if (addRatingRes?.status === 200) {
          setUpdate(!update)
          toast.success(addRatingRes?.message);
          console.log(addRatingRes, "addRatingRes");
          setSubmitting(false);
          handleClose();
        } else if (addRatingRes?.status === 400) {
          toast.error(addRatingRes?.message);
          console.log(addRatingRes?.message, "### ERROR ###");
        }
      } else {
        console.log("******** ERROR IN VALUES ********");
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="give_rating_modal"
    >
      <button onClick={handleClose} className="cross_btn" type="button">
        <CrossIcon />
      </button>
      <h2>Rate my performance</h2>
      <p>
        Rate the influencer's performance on your auction to assist others in
        improving their own auctions.
      </p>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form className="desc_box">
            {/* Star Rating */}
            <ul className="rating_stars">
              {Array.from({ length: 5 }).map((_, index) => (
                <li
                  key={index}
                  className={`star_icon ${
                    index < values?.rating ? "active" : ""
                  }`}
                  onClick={() => setFieldValue("rating", index + 1)}
                >
                  <StarIcon />
                </li>
              ))}
            </ul>

            {/* Description Field */}
            <label htmlFor="desc">Enter a short description about you</label>
            <Field as="textarea" id="desc" name="desc" placeholder="" />
            <ErrorMessage
              name="desc"
              component="div"
              className="error_message"
            />

            {/* Submit Button */}
            <button type="submit" className="rating_btn green_btn">
              Submit Review
            </button>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default GiveRatingModal;
